import { render, staticRenderFns } from "./OldPriceText.vue?vue&type=template&id=4b8b73a7&scoped=true&"
import script from "./OldPriceText.vue?vue&type=script&lang=js&"
export * from "./OldPriceText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b73a7",
  null
  
)

export default component.exports